import { Fragment, useCallback, useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import Avatar from "@mui/material/Avatar";
import ListItem from "@mui/material/ListItem";
import Typography from "@mui/material/Typography";
import PersonIcon from "@mui/icons-material/Person";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Switch, { SwitchProps } from "@mui/material/Switch";
import CircularProgress from "@mui/material/CircularProgress";

import { getSettings, changeSettings } from "../utils/api";
import { useStore } from "../store";

import createAuthComponent from "../router/createAuthComponent";

function Home() {
  const store = useStore();
  const [show, setShow] = useState(true);
  const [loading, setLoading] = useState(true);
  const { enqueueSnackbar } = useSnackbar();
  const { userInfo } = store;

  const handleChange = useCallback(
    (event) => {
      setLoading(true);
      changeSettings({ show: event.target.checked })
        .then((data) => {
          setShow(data.show);
          setLoading(false);
          enqueueSnackbar("Successfully!", {
            variant: "success",
          });
        })
        .catch((e) => {
          setLoading(false);
          enqueueSnackbar(e.message || "Fail!", {
            variant: "error",
          });
        });
    },
    [enqueueSnackbar]
  );

  useEffect(() => {
    setLoading(true);
    getSettings()
      .then((data) => {
        setShow(data.show);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const otherProps: SwitchProps = {
    disabled: loading,
  };

  if (loading) {
    otherProps.icon = <CircularProgress size={20} />;
    otherProps.checkedIcon = <CircularProgress size={20} />;
  }

  return (
    <Fragment>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          bgcolor: "background.paper",
        }}
      >
        <Avatar
          variant="square"
          alt={userInfo?.name || userInfo?.login}
          src={userInfo?.avatarUrl || ""}
          sx={{ width: 120, height: 120, mr: 2, fontSize: 70 }}
        >
          {(userInfo?.name || userInfo?.login || "").slice(0, 1)}
        </Avatar>
        <Typography
          sx={{
            flex: 1,
          }}
          variant="h3"
          noWrap={true}
        >
          {userInfo?.name || userInfo?.login}
        </Typography>
      </Box>
      <List sx={{ width: "100%", bgcolor: "background.paper", mt: 1 }}>
        <ListItem>
          <ListItemIcon>
            <PersonIcon />
          </ListItemIcon>
          <ListItemText
            id="switch-list-label-wifi"
            primary="Show profile & repositories"
          />
          <Switch checked={show} onChange={handleChange} {...otherProps} />
        </ListItem>
      </List>
    </Fragment>
  );
}

export default createAuthComponent(Home);
